module.exports = __webpack_public_path__ + "static/img/meiti.355d5736.png";